import React, { Component } from 'react';
// import "../../css/table.css"
import "datatables.net-bs4/css/dataTables.bootstrap4.css"
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css';
const $ = require('jquery');
require('jszip');
require('pdfmake');
$.DataTable = require('datatables.net-bs4');
// require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
require('datatables.net-buttons/js/buttons.colVis.js');
require('datatables.net-buttons/js/buttons.flash.js');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
// require('datatables.net-searchpanes-bs4');

class Parent extends Component {
    studentData = [
        { roll: 1, name: "Deepak Kumar", classes: "Std 1", parent: "Ghanshayam Vishwakarma", address: "Japla", Phone: "8083717128" },
        { roll: 2, name: "Ashutosh Kumar", classes: "Std 1", parent: "Ram Kumar Vishwakarma", address: "Ranchi", Phone: "9570813812" },
        { roll: 3, name: "Sandeep Mandal", classes: "Std 1", parent: "Umesh Mandal", address: "Patratu", Phone: "8873882108" },
        { roll: 4, name: "Rahul Murmu", classes: "Std 1", parent: "Rosewell Murmu", address: "Ramghar", Phone: "8083717128" },
        { roll: 5, name: "Ayushi Upadhyay", classes: "Std 1", parent: "Unkonwn Person", address: "Ramghar", Phone: "8083717128" },
        { roll: 6, name: "Riya Kumari", classes: "Std 1", parent: "Dhananjay Gupta", address: "Japla", Phone: "8083717128" },
        { roll: 7, name: "Jhandish", classes: "Std 1", parent: "Unkonwn Person", address: "Ratu Road", Phone: "8083717128" },
        { roll: 8, name: "Akash Pandey", classes: "Std 1", parent: "Unkonwn Person", address: "Khelgaon", Phone: "8083717128" },
        { roll: 9, name: "Ravi Jaiswal", classes: "Std 1", parent: "Unkonwn Person", address: "Ramghar", Phone: "8083717128" },
        { roll: 10, name: "Khusboo Poddar", classes: "Std 1", parent: "Unkonwn Person", address: "Ramghar", Phone: "8083717128" },
        { roll: 11, name: "Mona Ravi", classes: "Std 1", parent: "Ravi Jaiswal", address: "Assam", Phone: "8083717128" },
    ]
    componentDidMount() {
        this.studentData = this.studentData.map((row) => {
            row['action'] = "<button class='btn btn-info btn-sm'><i class='fa fa-edit'></i></button>&nbsp;<button class='btn btn-danger btn-sm'><i class='fa fa-trash-o'></i></button>";
            return row
        });
        this.$el = $(this.el);
        var table = this.$el.DataTable({
            // lengthChange: false,
            dom: 'lBfrtip',
            data: this.studentData,
            columns: [
                { data: 'roll' },
                { data: 'name' },
                { data: 'classes' },
                { data: 'parent' },
                { data: 'address' },
                { data: 'Phone' },
                { data: "action" }
            ],

            buttons: [
                // {
                //     extend: 'pdf',
                //     text: 'PDF',
                //     className: 'btn btn-success'
                // },
                {
                    extend: 'csv',
                    text: 'CSV',
                    title: "Students Records",
                    className: 'btn btn-success btn-sm'
                },
                {
                    extend: 'print',
                    text: 'Print',
                    title: "<h1 class='text-center'>Student Record</h1>",
                    className: 'btn btn-success btn-sm'
                }
            ]
        });
        table.buttons().container().appendTo(".export-buttons ");
        $('#myTable tbody').on('dblclick', 'tr', function () {
            var data = table.row(this).data();
            console.log(data);
            alert('You clicked on ' + data.name + '\'s row');
        });

    }
    render() {


        return (
            <div>
                {/* <h2 className="text-secondary" style={{ paddingLeft: "0.5rem", paddingTop: "1rem" }}>Student</h2> */}
                <div className="card card-design-2">
                    <div className="card-header bg-primary text-white">
                        Parent List by Classes
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-lg-4 col-sm-12">
                                <div className="row">
                                    <div className="mr-1 pd-1"> Select Class</div>
                                    <select className="form-control"><option>Std 1</option></select>
                                </div>
                            </div>
                            <div className="col-lg-8 col-sm-12 text-right export-buttons">

                                {/* <div className="export-buttons"></div> */}
                            </div>
                        </div>
                        <div className="row">
                            <div className=" table-responsive" style={{ padding: "10px" }}>
                                <table id="myTable" className="table table-hover table-bordered dt-responsive nowrap" width="100%" ref={el => this.el = el} >
                                    <thead>
                                        <tr>
                                            <th>Roll No</th>
                                            <th>Full Name</th>
                                            <th>Class</th>
                                            <th>Parent</th>
                                            <th>Address</th>
                                            <th>Phone</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Parent;